import useGetOrganization from '@/hooks/queries/organization-api/useGetOrganization';
import useGetReservation from '@/hooks/queries/reservations-api/useGetReservation';
import { useCurrentLanguage } from '@/hooks/useCurrentLanguage';
import { getTimeZone } from '@/utils/dates';
import { format, formatDistanceStrict } from 'date-fns';
import { useParams } from 'react-router-dom';

const useReservationDetail = () => {
  const params = useParams();
  const id = params.id ? params.id : '';
  const currentLocale = useCurrentLanguage();

  const {
    data: reservation,
    isLoading,
    isFetching,
    isError
  } = useGetReservation(id);

  const { data: organization } = useGetOrganization();

  const startTime =
    reservation?.startTime &&
    organization?.tz &&
    getTimeZone(Number(reservation.startTime), organization?.tz);
  const endTime =
    reservation?.endTime &&
    organization?.tz &&
    getTimeZone(Number(reservation.endTime), organization?.tz);
  const day = startTime
    ? format(startTime, "dd 'de' MMMMMMM 'del' yyyy", { locale: currentLocale })
    : undefined;
  const time = startTime ? format(startTime, 'H:mm') : undefined;
  const duration =
    startTime && endTime ? formatDistanceStrict(startTime, endTime) : undefined;

  return {
    reservation,
    isLoading,
    isFetching,
    isError,
    day,
    time,
    duration
  };
};

export default useReservationDetail;
